const selectPassword = state => {
    return {
      ...state.password
    };
  };
  
  export { selectPassword };
  